import get from 'get-value';
import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const adminAnsweringSchemaList = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    isAnsweringSchemaListLoading: false,
    listData: [],
    shortListData: [],
    pages: 0,
}, action) => {
    switch (action.type) {
        case aseWebsocketCommands.ASE_ANSWERING_SCHEMA_LIST_FETCH_PENDING: {
            return Object.assign({}, state, { isTableLoading: true });
        }
        case aseWebsocketCommands.ASE_ANSWERING_SCHEMA_LIST_SEND: {
            const { correlationId } = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    listData: get(action, 'payload.result.data', { default: [] }),
                    pages: get(action, 'payload.result.pages', { default: 0 }),
                    correlationId
                });
            }
        }
        case aseWebsocketCommands.ASE_ANSWERING_SCHEMA_LIST_SEND_ERROR: {
            const { correlationId } = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, { isTableLoading: false, correlationId });
            }
        }
        default:
            return state;
    }
};
